var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8947 6.84211V10.9337C21.8947 10.9337 19.1716 10.9474 19.1579 10.9337V6.84211H15.0526C15.0526 6.84211 15.0663 4.11895 15.0526 4.10526H19.1579V0H21.8947V4.10526H26V6.84211H21.8947ZM17.7895 12.3158V8.21053H13.6842V4.10526H2.73684C1.23158 4.10526 0 5.33684 0 6.84211V23.2632C0 24.7684 1.23158 26 2.73684 26H19.1579C20.6632 26 21.8947 24.7684 21.8947 23.2632V12.3158H17.7895ZM2.73684 23.2632L6.84211 17.7895L9.57895 21.8947L13.6842 16.4211L19.1579 23.2632H2.73684Z",
    fill: "#3485FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.9afe5d80a151623d8c0161dd3f786df0.svg";
export { ForwardRef as ReactComponent };